import './styles.scss'
import React from 'react'

export default function DesktopPopularCities ({ cities }) {
  return (
    <div className='grid-all'>
      <div className='col-1-1 cities-list'>
        {cities.map((city, index) => (
          <p key={index} className={`group-${city.group}`}>
            <a href={city.url} title={city.title}>
              {city.city}
            </a>
          </p>
        ))}
      </div>
    </div>
  )
}
